import { icons } from '../../img/icons.svg';

export default class View{
    _data
    render(data, render = true){
        if((Array.isArray(data) && data.length == 0) || !data ) return this.renderError();
        this._data = data;
        const markup = this._generateMarkup();
        if (!render) return markup;
        this._clear();
        this._parentEl.insertAdjacentHTML('afterbegin', markup);
    }

    update(data){
        this._data = data;
        const newMarkup = this._generateMarkup();

        const newDOM = document.createRange().createContextualFragment(newMarkup);
        const newElements = Array.from(newDOM.querySelectorAll('*'));
        const currElement = Array.from(this._parentEl.querySelectorAll('*'));
        newElements.forEach((newEl, i)=> {
            const curEl = currElement[i];
            if(!newEl.isEqualNode(curEl) && newEl.firstChild.nodeValue.trim() !== ''){
                curEl.textContent = newEl.textContent;
            }
            if (!newEl.isEqualNode(curEl))
                Array.from(newEl.attributes).forEach(attr =>
                curEl.setAttribute(attr.name, attr.value)
                );
        });
    }
    _clear(){
        this._parentEl.innerHTML = '';
    }

    renderError(message = this._errorMes){
        const markup = `<div class="error">
        <div>
          <svg>
            <use href="${icons}#icon-alert-triangle"></use>
          </svg>
        </div>
        <p>${message}</p>
      </div>`;
      this._clear();
      this._parentEl.insertAdjacentHTML('afterbegin',markup);
    }

    renderMessage(message = this._message){
        const markup = `<div class="message">
        <div>
          <svg>
            <use href="${icons}#icon-smile"></use>
          </svg>
        </div>
        <p>${message}</p>
      </div>`;
      this._clear();
      this._parentEl.insertAdjacentHTML('afterbegin',markup);
    }


    renderSpinner = function(){
        const markup= `<div class="spinner">
        <svg>
          <use href="${icons}#icon-loader"></use>
        </svg>
      </div>`;
      this._clear();
      this._parentEl.insertAdjacentHTML('afterbegin',markup);
    }
}